import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoSs: CultureInfo = {
  name: 'ss',
  displayName: 'siSwati',
  iso3LanguageCode: 'ssw',
  iso2LanguageCode: 'ss',
  ietfLanguageTag: 'ss',
  parent: null
};
